import styled from "styled-components";

export const Body = styled.div`
  background: #1c3869;
  padding: 15px;
`;

export const Container = styled.div`
  background: #fff;
  text-align: justify;

  color: #1c3869;
  padding: 30px;
  font-family: "Open Sans", sans-serif;

  h2 {
    font-weight: 700;
    font-size: 1.2rem;
    margin: 10px 0;
  }

  > div {
    width: 50%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0 auto;

    img {
      width: 150px;
      margin-bottom: 30px;
    }

    h1 {
      font-weight: 700;
      font-size: 1.2rem;
      margin: 50px 0;
    }

    p {
      margin: 20px;
      font-size: 1.2rem;
      line-height: 1.6rem;

      i,
      u,
      b {
        font-size: 1.2rem;
      }
    }

    ol {
      p {
        font-size: 1.2rem;
        line-height: 2rem;
      }

      ol {
        margin: 5px 40px;

        li {
          font-size: 1.2rem;
          line-height: 2rem;
        }
      }
    }
  }
`;
